export default __webpack_public_path__ + "static/media/portfolio.db92863e.jpeg";